<template>
  <base-event-log-item
    :icon="icon"
    :icon-color="iconColor"
    :researcher="referenceEventLog.eventBy"
    :date="referenceEventLog.createdAt"
    :bottom-node="bottomNode"
  >
    <div class="text-overflow-ellipsis">
      <span
        v-if="
          referenceEventLog.event ===
          ReferenceEvent.FULL_TEXT_PDF_FETCH_STARTED
        "
      >
        Started searching for a full-text PDF.
      </span>
      <span
        v-else-if="
          referenceEventLog.event ===
          ReferenceEvent.FULL_TEXT_PDF_FETCH_NOT_FOUND
        "
      >
        No direct PDF was found. Many publishers restrict downloads.
      </span>
      <span
        v-else-if="
          referenceEventLog.event ===
          ReferenceEvent.FULL_TEXT_PDF_FETCH_ERROR
        "
      >
        Error fetching full-text PDF
        <v-tooltip v-if="error" bottom>
          <template #activator="{ on }">
            <v-icon x-small class="ml-1" v-on="on">info</v-icon>
          </template>
          <span>{{ error }}</span>
        </v-tooltip>
      </span>
    </div>
  </base-event-log-item>
</template>

<script>
import BaseEventLogItem from './BaseEventLogItem';
import { ReferenceEventLog } from '@/models';
import { ReferenceEvent } from '@/enums';

const EVENT_TO_STYLE_PROPS = {
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_STARTED]: {
    icon: { name: 'cloud_download', color: 'info' },
  },
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_NOT_FOUND]: {
    icon: { name: 'cloud_off', color: 'warning' },
  },
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_ERROR]: {
    icon: { name: 'error_outline', color: 'error' },
  },
};

export default {
  name: 'FullTextPdfFetchEventLogItem',
  components: { BaseEventLogItem },
  props: {
    referenceEventLog: {
      type: ReferenceEventLog,
      required: true,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ ReferenceEvent }),
  computed: {
    error() {
      return this.referenceEventLog.payload?.error;
    },
    icon() {
      return this.styleProps?.icon.name;
    },
    iconColor() {
      return this.styleProps?.icon.color;
    },
    styleProps() {
      return EVENT_TO_STYLE_PROPS[this.referenceEventLog.event];
    },
  },
};
</script>
